import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import { Box, Typography } from "@mui/material";
import theme from "./styles/theme";
import "./styles/styles.css";
import Logo from "./components/Logo/Logo";
import "./styles/fonts.css";
import WebDevelopment from "./pages/WebDevelopment";
import Photography from "./pages/Photography";
import Design from "./pages/Design";
import AudioComposition from "./pages/AudioComposition";
import Craftmanship from "./pages/Craftmanship";
import AboutMe from "./pages/AboutMe";
import ImprintPrivacy from "./pages/ImprintPrivacy";

function MainLayout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Header
        title={"Hendrik Grygas"}
        navLinks={[
          { label: "WebDevelopment", href: "/WebDevelopment" },
          { label: "Photography", href: "/Photography" },
          { label: "Design", href: "/Design" },
          { label: "AudioComposition", href: "/AudioComposition" },
          { label: "Craftmanship", href: "/Craftmanship" },
          { label: "AboutMe", href: "/AboutMe" },
        ]}
      />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <div
          className="Hendrik-Grygas"
          id="Hendrik-Grygas"
          style={{
            minHeight: "100vh",
          }}
        >
          <Routes>
            {/* Imprint route without header and footer */}
            <Route path="/imprint-privacy" element={<ImprintPrivacy />} />
            
            {/* All other routes with header and footer */}
            <Route
              path="/"
              element={
                <MainLayout>
                  <Box>
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        minHeight: "100vh",
                        backgroundColor: "#443F35",
                      }}
                    >
                      <Typography variant="h1" sx={{ color: "#443F35", textAlign: "center", fontSize: "0.1rem !important",  }}>
                        Hendrik Grygas – Web Developer, Designer & Creative Professional
                      </Typography>
                      <Logo></Logo>
                    </Box>
                  </Box>
                </MainLayout>
              }
            />
            <Route
              path="/WebDevelopment"
              element={
                <MainLayout>
                  <WebDevelopment />
                </MainLayout>
              }
            />
            <Route
              path="/Photography"
              element={
                <MainLayout>
                  <Photography />
                </MainLayout>
              }
            />
            <Route
              path="/Design"
              element={
                <MainLayout>
                  <Design />
                </MainLayout>
              }
            />
            <Route
              path="/AudioComposition"
              element={
                <MainLayout>
                  <AudioComposition />
                </MainLayout>
              }
            />
            <Route
              path="/Craftmanship"
              element={
                <MainLayout>
                  <Craftmanship />
                </MainLayout>
              }
            />
            <Route
              path="/AboutMe"
              element={
                <MainLayout>
                  <AboutMe />
                </MainLayout>
              }
            />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
